/**
 * Fractional indexing for board card order (BLUEPRINT §6). Ranks are strings
 * over a sorted base-62 alphabet, compared lexicographically; a new rank can
 * always be made between two neighbours without touching other rows.
 * Generated ranks never end in the smallest digit, so there is always room
 * below any rank.
 */
const CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const BASE = CHARS.length;
const idx = (ch) => {
    const i = CHARS.indexOf(ch);
    if (i < 0)
        throw new Error(`bad rank character ${JSON.stringify(ch)}`);
    return i;
};
/** A rank strictly between `a` and `b`; null means "no neighbour on that side". */
export function rankBetween(a, b) {
    const lo = a ?? "";
    if (b !== null && lo >= b)
        throw new Error(`rankBetween: ${JSON.stringify(lo)} is not below ${JSON.stringify(b)}`);
    if (b === null) {
        // Append: bump the last digit so repeated appends stay short (one extra char per 31 appends).
        if (lo === "")
            return "V";
        const last = idx(lo[lo.length - 1]);
        return last < BASE - 1 ? lo.slice(0, -1) + CHARS[last + 1] : lo + "V";
    }
    if (a === null) {
        // Prepend: lower the last digit; below "1" step into a longer string ("1" → "0V").
        const last = idx(b[b.length - 1]);
        return last > 1 ? b.slice(0, -1) + CHARS[last - 1] : b.slice(0, -1) + "0V";
    }
    let out = "";
    let hiOpen = b === null;
    for (let i = 0; i < 128; i++) {
        const x = i < lo.length ? idx(lo[i]) : 0;
        const y = hiOpen ? BASE : i < b.length ? idx(b[i]) : BASE;
        if (x === y) {
            out += CHARS[x];
            continue;
        }
        if (y - x > 1)
            return out + CHARS[Math.floor((x + y) / 2)];
        out += CHARS[x];
        hiOpen = true;
    }
    throw new Error("rankBetween: ranks too long; rebalance needed");
}
/** Compare two ranks (plain string order), then break ties by id so order is total. */
export function compareRank(a, b) {
    return a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : a.issueId - b.issueId;
}
//# sourceMappingURL=rank.js.map